import { HoverCard, HoverCardTrigger, HoverCardContent } from "@/components/ui/hover-card";

// Thumbnail that pops an enlarged preview on hover.
// ``zoomSrc`` (optional) lets callers pass a HIGHER-resolution URL for the
// hover popup while keeping ``src`` as a small thumbnail — used across the
// product list so we don't ship multi-MB originals just to render a 56×48
// cell (2026-02).
// ``fallbackSrc`` (2026-07) — swapped in when ``src`` fails to load (e.g. the
// direct-R2 thumbnail 404s because it was never warmed). Only when THAT also
// fails do we hide the image.
export const PhotoZoom = ({ src, zoomSrc, alt, className, side = "right", fallbackSrc }) => (
  <HoverCard openDelay={150} closeDelay={50}>
    <HoverCardTrigger asChild>
      <img
        src={src}
        alt={alt}
        loading="lazy"
        onError={(e) => {
          const img = e.currentTarget;
          if (fallbackSrc && img.dataset.fallbackTried !== "1" && fallbackSrc !== img.src) {
            img.dataset.fallbackTried = "1";
            img.src = fallbackSrc;
          } else {
            img.style.display = "none";
          }
        }}
        className={`${className} cursor-zoom-in`}
      />
    </HoverCardTrigger>
    <HoverCardContent side={side} className="w-auto max-w-none p-1.5 bg-white border border-border shadow-lg" data-testid="photo-zoom-preview">
      <img src={zoomSrc || src} alt={alt} className="max-w-[480px] max-h-[400px] object-contain" />
    </HoverCardContent>
  </HoverCard>
);
